module.exports = __webpack_public_path__ + "images/people-1-1056ad516a164f7d0aa32bca229c2e76.jpg";